import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// styles
import * as styles from "./Investors.module.css";

const investorsData = [
  {
    name: "Sequoia",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/sequoia.png"
        alt="Sequoia"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "ICONIQ",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/iconiq_2.png"
        alt="ICONIQ"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "Temasek",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/temasek.png"
        alt="Temasek"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "Sofina",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/sofina_2.png"
        alt="Sofina"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "Helena",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/helena.png"
        alt="Helena"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "Corner Ventures",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/corner-ventures.png"
        alt="Corner Ventures"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "LTS Investments",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/lts-investments.png"
        alt="LTS Investments"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "Perceptive Advisors",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/perceptive-advisors.png"
        alt="Perceptive Advisors"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
  {
    name: "Truarrow Partners",
    logo: (
      <StaticImage
        src="../../../images/aboutUs/truarrow-partners.png"
        alt="Truarrow Partners"
        placeholder="blurred"
        quality={100}
        objectFit="contain"
        loading="lazy"
      />
    ),
  },
];

const Investors = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className={styles.investorsSection}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Heading */}
        <div className="row">
          <div className="col-12">
            <h2 className={styles.sectionTitle}>Investors</h2>
          </div>
        </div>

        {/* Investors Grid */}
        <div className={`row ${styles.investorsGrid}`}>
          {investorsData.map((investor, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-4">
              <div className={styles.investorCard}>
                <div className={styles.logoWrapper}>{investor.logo}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Investors;
